import {MultiplasButton} from '../../multiplasService';

/**
 * XPicksButton - Emerald terminal-style button matching homepage design
 * Uses MultiplasButton with terminal variant for Bloomberg-style appearance
 */
const XPicksButton = ({ gameData, sport = '', label = 'xPicks', icon: Icon }) => (
  <div className="flex-1 flex items-stretch [&>button]:w-full [&>button]:h-full [&>button]:min-h-[42px] [&>button]:px-3 [&>button]:py-2 [&>button]:rounded-lg [&>button>span]:!text-[11px]">
    <MultiplasButton
      gameData={gameData}
      sport={sport}
      variant="terminal"
      size="compact"
      showConfirmation={false}
    />
    {/* Accessible label retains the CTA context even though MultiplasButton owns its own text */}
    <span className="sr-only">
      {label}
      {Icon ? ' button' : ''}
    </span>
  </div>
);

export default XPicksButton;
